export default function ForWhom() {
  const profiles = [
    {
      icon: 'ri-briefcase-line',
      title: 'Emprendedores',
      description: 'Que necesitan capital para lanzar o escalar su negocio sin comprometer su liquidez.'
    },
    {
      icon: 'ri-store-line',
      title: 'Dueños de Negocio',
      description: 'Que buscan financiamiento estratégico para expansión, inventario o equipamiento.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Profesionales Inversionistas',
      description: 'Que quieren aprovechar capital a 0% para invertir y multiplicar sus retornos.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Personas con Crédito Trabajado',
      description: 'Que ya tienen un perfil crediticio sólido y están listos para el siguiente nivel.'
    }
  ];

  return (
    <section className="py-24 bg-[#1C1C1C] relative">
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/50 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            ¿Para Quién es <span className="text-[#D4AF37]">Este Servicio</span>?
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            El Funding de Cashflow VIP está diseñado para perfiles específicos que buscan crecimiento estratégico
          </p>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mt-6"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {profiles.map((profile, index) => (
            <div
              key={index}
              className="bg-[#050505]/50 p-6 rounded-xl border border-[#D4AF37]/20 hover:border-[#D4AF37]/60 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#D4AF37]/10 rounded-full flex items-center justify-center mb-4">
                <i className={`${profile.icon} text-[#D4AF37] text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-3">
                {profile.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                {profile.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
